import React, { Component } from 'react';
import { compose, lifecycle, withHandlers, withState } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { toggleAddProgrammePopup, toggleNotification, toggleResubmissionPopup } from '../../redux/reducers/view';
import { getUserProgramsFullRequest, selectAssessment, selectAssessmentContent, selectRollout, selectUserContent, selectUserModule, selectUserPrograms, setApproved, setCost } from '../../redux/reducers/userProgramsFull';

import Popup from '../Popup';
import AddCodeForm from '../Form/AddCodeForm';

import { commonStyles, COLORS } from '../../styles/styles';
import addCodeKeyImage from '../../assets/add_code_key.svg';

import * as moment from 'moment';

import md5 from "md5";

import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBIcon, MDBSelect } from 'mdbreact';
import { connectedUsersRequest } from '../../redux/reducers/connectedUsers';

import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ScaleLoader from 'react-spinners/ScaleLoader';
import ResubmissionComponent from '../ResubmissionComponent';

import FileActions from '../FileActions';
import { selectedContent } from '../../redux/selectors';
import { assignmentRequestRequest, setComment, setFile, setFileCount, setFileIndex, setMediaType, setRequestType } from '../../redux/reducers/assignmentRequest';

class ResubmissionPopup extends Component {
  state = {
    modal: true,
    page: 'decision',
    selectedFiles: [],
    progressInfos: [],
    message: [],
    fileInfos: [],
    comment:'',
    mediaType: 'document',
    index: 0,
    options: [{"text":'Proof of payment', "value":'pop'}, {"text":'Corroborating documents', "value":'document'}]
  };

  constructor() {
    super();
    this.hiddenFileInput = React.createRef();
  }
  componentWillMount(){
    this.setState({comment:''})
    this.setState({
      progressInfos: [],
      selectedFiles: [],
    });
  }

  componentWillReceiveProps(nextProps){
    
    if(nextProps.assignmentRequestReducer.fetching==true && this.props.assignmentRequestReducer.fetching==false){
      
    }else if(nextProps.assignmentRequestReducer.isFetched==true && this.props.assignmentRequestReducer.isFetched==false && this.props.view.resubmissionPopup){
      
      if(this.props.assignmentRequestReducer.fileIndex<this.props.assignmentRequestReducer.file_count){
         this.sendRequest(null)
        this.setState({page:'loading'})
      }else{
        
        this.props.setFileIndex(0)
        this.props.setFileCount(0)
        this.setState({page:'completed'})
      }
    }else if(nextProps.assignmentRequestReducer.isFetched==false && this.props.assignmentRequestReducer.isFetched==true && this.props.view.resubmissionPopup){
      
      this.setState({page:'decision', options:[{"text":'Proof of payment', "value":'pop'}, {"text":'Corroborating documents', "value":'document'}]})
    
    }
    

    
    
  }


  toggle = (e) => {
    
  
    this.setState({comment:'', selectedFiles:[], mediaType:'document', page:'decision', index:0})
   this.props.toggleResubmissionPopup(false)
  }

  showRequest = (e) => {
    this.setState({page:"upload"})
   }
   showCompleted= (e) => {
    
   }
   showDecision= (e) => {
    
    this.setState({page:"decision"})
   }

   payment = (e) => {
    this.refs.payfast.submit();
   }
   removeFile = (e) => {
    
    var tmp = this.state.selectedFiles
    for (let index = 0; index < tmp.length; index++) {
      if(e.name==tmp[index].name){
        tmp.splice(index,1)
      }
    }
    this.setState({
      progressInfos: [],
      selectedFiles: tmp,
    });
   }

   handleClick = event => {
    
    this.hiddenFileInput.current.click();
  };

  sendRequest = event => {
    
      
      
      
      this.props.setComment(this.state.comment);
      this.props.setFile(this.state.selectedFiles[this.props.assignmentRequestReducer.fileIndex]);
      this.props.setMediaType(this.state.mediaType);
      this.props.setFileCount(this.state.selectedFiles.length);
      this.props.selectUserPrograms(parseInt(this.props.userProgramsFull.assessmentContent.program_id))
      this.props.selectUserModule(parseInt(this.props.userProgramsFull.assessmentContent.module_id))
      this.props.selectAssessment(parseInt(this.props.userProgramsFull.assessmentContent.survey_id))
      this.props.selectRollout(parseInt(this.props.userProgramsFull.assessmentContent.rollout_id))
      this.props.setRequestType('retake')
      this.props.setCost(this.props.userProgramsFull.assessmentContent.survey_cost)
      this.props.selectUserContent(parseInt(this.props.userProgramsFull.assessmentContent.contentId))
      this.props.setApproved(0)
      this.props.assignmentRequestRequest('retake')  
      this.props.setFileIndex(this.props.assignmentRequestReducer.fileIndex+1)      
    
    
    this.setState({page:"loading"})
   
  };

  handleChange = event => {
    const fileUploaded = event.target.files;
    var files= [];
    for (let index = 0; index < fileUploaded.length; index++) {
      const element = fileUploaded[index];
      
      files.push(element)
    }
   
    this.setState({
      progressInfos: [],
      selectedFiles: files,
    });
    //setImage(event.target.files[0])
  };

  handleChangeComment = event => {
    
    this.setState({comment:event})
  }
  onChangeDoc = event => {
    if(this.state.mediaType!=event[0] && event.length!=0){
      if(event[0]=='pop'){
       this.setState({mediaType:event[0], options:[{"text":'Proof of payment', "value":'pop', "checked":true}, {"text":'Coroborating documents', "value":'document'}]})
      }else{
       this.setState({mediaType:event[0], options:[{"text":'Proof of payment', "value":'pop'}, {"text":'Coroborating documents', "value":'document', "checked":true}]})
      }
      
     }
    
   }

  render() {
    const timerStr = this.props.loginReducer.user && this.props.loginReducer.user.userId+'-'+moment().format("X");
    const params = new URLSearchParams({
      merchant_id: "17694422",
      merchant_key: "3qdvwf3bonmqn",
      return_url: "https://cpslearn.co.za/student"+this.props.location.pathname+'?accepted=true&reference='+timerStr+'&rollout_id='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.rollout_id)+'&program_id='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.program_id)+'&module_id='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.module_id)+'&survey_id='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.survey_id)+'&type=retake&cost='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.survey_cost)+'&content_id='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.contentId),
      cancel_url: "https://cpslearn.co.za/student"+this.props.location.pathname+'?accepted=false',
      notify_url: "https://cpslearn.co.za/student"+this.props.location.pathname+'?accepted=middle',
      name_first: this.props.loginReducer.user && this.props.loginReducer.user.firstName,
      name_last: this.props.loginReducer.user && this.props.loginReducer.user.lastName,
      email_address: this.props.loginReducer.user && this.props.loginReducer.user.email,
      amount: (this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.survey_cost),
      item_name: timerStr,
      passphrase:escape("Cpslearn_payments_2021")

    });

    // passphrase: escape( "Cpslearn_payments_2021" ),
    const MD5Signature = md5(params.toString())


    return (
      // <MDBContainer>
      //     <MDBModal isOpen={this.props.view.resubmissionPopup} toggle={this.toggle}   centered >
      //       <MDBModalHeader id="alert-dialog-title " className="m-1 default-color" toggle={this.toggle}>
      //         <div className="dialogHeader ">Resubmission Request</div>
      //       </MDBModalHeader>
      //       <MDBModalBody>
      //       The cost of a resubmission request for this rollout is R50.00.  If you would like to pay electronically click Pay Now. Alternatively, you can submit a request for consideration.
      //       <MDBBtn 
      //     right
      //     size="md"
      //     className='mt-5 btn-green'
      //     style={{float:'right'}}
      //     action
      //     >
      //   REQUEST
      // </MDBBtn>
      // <form action="https://sandbox.payfast.co.za/eng/process" method="POST">
      //       <input type="hidden" name="merchant_id" value="10000100" />
      //       <input type="hidden" name="merchant_key" value="46f0cd694581a" />
      //       <input type="hidden" name="return_url" value="https://cpslearn.co.za/student/paymentscreen" />
      //       <input type="hidden" name="cancel_url" value="https://cpslearn.co.za/student/cancelscreen" />
      //       <input type="hidden" name="notify_url" value="https://cpslearn.co.za/student/notifyscreen" />
      //       <input type="hidden" name="name_first" value={"Shaun"} />
      //       <input type="hidden" name="email_address" value={"shaun@digitalflux.co.za"} />
      //       <input type="hidden" name="m_payment_id" value={"1"} />
      //       <input type="hidden" name="amount" value={"500"} />
      //       <input type="hidden" name="item_name" value={"Test payment"} />
      //       <input type="hidden" name="item_description" value={"test description"} />
      //       <input type="hidden" name="signature" value={MD5Signature} />
      //       <MDBBtn 
      //     right
      //     size="md"
      //     className='mt-5 btn-green'
      //     style={{float:'right'}}
      //     action
      //     type="submit"
      //     >
      //   PAY NOW
      // </MDBBtn>
      //     </form>
      //       <ReactCSSTransitionGroup
      //       transitionName="fade"
      //       transitionEnterTimeout={500}
      //       transitionLeaveTimeout={500}>{this.props.loading && <div style={{backgroundColor:'#FFFFFF', position:'absolute', top:0, left:0, height:'100%', width:'100%', zIndex:12000, textAlign:'center'}}>
      //       <div style={{position:'absolute', top:"40%", width:'100%'}}>
      //     <ScaleLoader
      //      height={35}
      //      width={4}
      //      radius={2}
      //      margin='2px'
      //     color={COLORS.yellow}
      //      loading={true}
      //    />
      //    </div>
      //     </div>}</ReactCSSTransitionGroup>
      //       </MDBModalBody>
      //     </MDBModal>
      //   </MDBContainer>
      // <Dialog
      //   open={true}
      //   onClose = {handleCloseNow}
      //   aria-labelledby="alert-dialog-title"
      //   aria-describedby="alert-dialog-description"
      //   classes={{paper:classes.dialogPaper}}
      // >
      //   <div style={{backgroundColor:'white', padding:8}}>
      //     <DialogTitle className={classes.dialogTitle} id="alert-dialog-title">
      //     Please enter the code of the program you would like to add</DialogTitle>
      //     <DialogContent className={classes.dialogContent}>
      //       <AddCodeForm/>
      //     </DialogContent>
      //   </div>
      // </Dialog>
      <div>
        <form action="https://www.payfast.co.za/eng/process" method="POST" ref="payfast">
           <input type="hidden" name="merchant_id" value="17694422" />
           <input type="hidden" name="merchant_key" value="3qdvwf3bonmqn" />
           <input type="hidden" name="return_url" value={"https://cpslearn.co.za/student"+this.props.location.pathname+'?accepted=true&reference='+timerStr+'&rollout_id='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.rollout_id)+'&program_id='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.program_id)+'&module_id='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.module_id)+'&survey_id='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.survey_id)+'&type=retake&cost='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.survey_cost)+'&content_id='+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.contentId)} />
           <input type="hidden" name="cancel_url" value={"https://cpslearn.co.za/student"+this.props.location.pathname+'?accepted=false'} />
           <input type="hidden" name="notify_url" value={"https://cpslearn.co.za/student"+this.props.location.pathname+'?accepted=middle'} />
           <input type="hidden" name="name_first" value={this.props.loginReducer.user && this.props.loginReducer.user.firstName} />
           <input type="hidden" name="name_last" value={this.props.loginReducer.user && this.props.loginReducer.user.lastName} />
           <input type="hidden" name="email_address" value={this.props.loginReducer.user && this.props.loginReducer.user.email} />
           <input type="hidden" name="amount" value={(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.survey_cost)} />
           <input type="hidden" name="item_name" value={timerStr} />
           <input type="hidden" name="signature" value={MD5Signature} />
           
    </form>
        <input type="file"
                 ref={this.hiddenFileInput}
                 style={{display:'none', position:'absolute', top:0, left:0}} 
                 onChange={this.handleChange}
                multiple
          />
        {this.props.view.resubmissionPopup && <div style={{height:'100%', width:'100%', position:'absolute', top:0, left:0, zIndex:100000}}>
        
        <ResubmissionComponent
          page={this.state.page}
          commentTxt = {{
            onChange: (e) => {
              this.handleChangeComment(e.target.value)
            },
            value: this.state.comment
          }}
          pricingTxt = {'The cost of a Resubmission Request for this rollout is R'+(this.props.userProgramsFull.assessmentContent && this.props.userProgramsFull.assessmentContent.survey_cost)+'.00. If you would like to pay electronically, click Pay Now.  Alternatively, you can submit your request for consideration or upload your proof of payment by clicking on Request.'
          }
          fileHolder = {{
            children : this.state.selectedFiles.map(item => (
              <div>
                
              
              <FileActions
                page={this.state.page}
                removeBtn = {{
                  onClick: (e) =>{
                    this.removeFile(item)
                  }
                }}
                fileName = {item.name}
              
              /></div>
                ))
          }}

          loadingHolder = {{
            children: <ReactCSSTransitionGroup
            transitionName="fade"
            transitionEnterTimeout={500}
            transitionLeaveTimeout={500}>
              <div>
           
          <ScaleLoader
           
           height={35}
           width={4}
           radius={2}
           margin='2px'
           color={COLORS.cornerstoneRed}
           loading={true}
         />
        </div>
         </ReactCSSTransitionGroup>
          }}
          closeBtn = {{
            onClick: (e) =>{
              this.toggle(e)
            }
          }}
          bigCloseBtn = {{
            onClick: (e) =>{
              this.toggle(e)
            }
          }}
          requestBtn = {{
            onClick: (e) =>{
              this.showRequest(e)
            }
          }}


          backBtn = {{
            onClick: (e) =>{
              
              this.showDecision(e)
            }
          }}
          payNowBtn= {{
            onClick: (e) =>{
              this.payment(e)
            }
          }}
          chooseBtn = {{
            onClick: (e) =>{
              
              this.handleClick(e)
            }
          }}
          sendBtn= {{
            onClick: (e) =>{
              
              this.sendRequest(e)
            }
          }}
          docType = {{
            children: <MDBSelect
              label='Type of document'
    
              options={this.state.options}
              getValue={this.onChangeDoc}
              style={{zIndex:10000}}
            />
          }}

        />
      </div>}
      </div>
    );
  }
  }

const styles = () => ({
  ...commonStyles,
  image: {
    width: 64,
    height: 64,
  },
  senderAvatar: {
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 500,
    color: '#50E3C2',
    flexShrink: 0,
    marginRight: 7,
    backgroundColor: '#4A4A4A',
    width: `70px`,
    height: `70px`,
  },

});

const mapStateToProps = state => ({
  view: state.viewReducer,
  assignmentRequestReducer: state.assignmentRequest,
  loginReducer: state.loginReducer,
  userProgramsFull: state.userProgramsFullReducer,
});
const mapDispatchToProps = dispatch => ({
  toggleResubmissionPopup: value => dispatch(toggleResubmissionPopup(value)),
  getUserProgramsFullRequest: () => dispatch(getUserProgramsFullRequest()),
  connectedUserRequest: () => dispatch(connectedUsersRequest()),
  toggleNotification: value => dispatch(toggleNotification(value)),
  assignmentRequest:string => dispatch(assignmentRequestRequest(string)),
  setComment:string => dispatch(setComment(string)),
  setFile:file => dispatch(setFile(file)),
  setFileCount:int => dispatch(setFileCount(int)),
  setMediaType:string => dispatch(setMediaType(string)),
  selectUserContent:int => dispatch(selectUserContent(int)),
  selectUserModule:int => dispatch(selectUserModule(int)),
  selectUserPrograms:int => dispatch(selectUserPrograms(int)),
  selectAssessmentContent:int => dispatch(selectAssessmentContent(int)),
  selectAssessment:int => dispatch(selectAssessment(int)),
  setFileIndex:int => dispatch(setFileIndex(int)),
  selectRollout:int => dispatch(selectRollout(int)),
  setRequestType:string => dispatch(setRequestType(string)),
  setCost:string => dispatch(setCost(string)),
  setApproved:string => dispatch(setApproved(string)),
  assignmentRequestRequest:string => dispatch(assignmentRequestRequest(string)),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withRouter,
  withState('loading', 'toggleLoading', false),
  withHandlers({
    handleCloseNow: props => event => {
      
      props.toggleResubmissionPopup(false)
    }
  }),
  lifecycle({
    componentWillUnmount() {
      //this.props.getUserProgramsFullRequest();
    },
    
  }),
  withStyles(styles),
)(ResubmissionPopup);

ResubmissionPopup.propTypes = {
  classes: PropTypes.instanceOf(Object),
  toggleAddProgrammePopup: PropTypes.func,
};
